import { createContext as e, useContext as o } from "react";
const n = e({
  toggle: () => {
  },
  setOpen: () => {
  }
});
function r() {
  const t = o(n);
  if (!t)
    throw new Error("useLayout must be used within a Layout");
  return t;
}
export {
  n as LayoutContext,
  r as useLayoutContext
};
